import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next'
import { IInformationModalProps } from 'shared/interfaces/i-api-informationModal'
import { ModalHeader, ModalBody, ModalFooter } from './components'

interface InformationModalProps {
	content: IInformationModalProps
	onClose: () => void
	show: boolean
}

export const InformationModal = ({
	content,
	onClose,
	show,
}: InformationModalProps) => {
	const { t } = useTranslation()

	if (!content) return null

	const {
		headerTitle,
		headerImage,
		bodyTitle,
		bodyText,
		ctaLink,
		ctaButtonText,
		showFooterButtonClose,
		css,
		isCtaLinkInternalNavigation,
	} = content

	return (
		<Modal
			show={show}
			onHide={onClose}
			className={`information-modal ${css}`}
			backdrop="static"
			animation={false}>
			<ModalHeader headerTitle={headerTitle} headerImage={headerImage} />
			<ModalBody bodyTitle={bodyTitle} bodyText={bodyText} />
			<ModalFooter
				isCtaLinkInternalNavigation={isCtaLinkInternalNavigation}
				ctaLink={ctaLink}
				ctaButtonText={ctaButtonText}
				showFooterButtonClose={showFooterButtonClose}
				onClose={onClose}
				t={t}
			/>
		</Modal>
	)
}
